'use strict';

const isAppleOAuthConnected = user => {
	const isAppleEnabled = user.selectedSite.analytics?.apple?.enabled || false;
	const isAppleOAuth = user.selectedSite.analytics?.apple?.connectionType === 'oauth' || false;
	return isAppleEnabled && isAppleOAuth;
};
const networksStates = ({ elm }) => {
	return [
		{
			name: 'site.Networks',
			url: '/networks',
			templateUrl: 'components/networks/pmtNetworksMenu.html',
			requiredPermission: 'permission/location.view',
			redirectTo: 'site.FacebookBrandPagesNew'
		},
		{
			name: 'site.Networks.BrandPages',
			url: '/brandpages?view',
			redirectTo: 'site.FacebookBrandPagesNew',
			requiredPermission: 'permission/location.view',
			params: {
				view: {
					value: 'default',
					squash: true
				}
			},
			reloadOnSearch: false
		},
		elm({
			name: 'site.FacebookBrandPagesNew',
			moduleName: 'BrandManagement.Facebook.Main',
			url: '/brandmanagement/facebook',
			requiredPermission: 'permission/location.view',
			pageTitle: 'listings.navigation.brand_pages_facebook',
			subscriptions: [
				'$document',
				'pmtElmService',
				($document, pmtElmService) => [
					{
						id: 'CropImage',
						f: async args => {
							const { cropperId, fileSuffix } = args;
							// I don't know why the document is an array, but at this point I am afraid to ask
							const cropper = $document[0].getElementById(cropperId);
							if (!cropper) {
								return;
							}

							const canvas = await cropper.captureImage();
							canvas.toBlob(blob => {
								const asFile = new File([blob], 'cropped-' + fileSuffix + '.png', {
									type: blob.type
								});
								pmtElmService.sendData(
									'BrandManagement.Facebook.Main',
									'onImageCaptured_Facebook',
									asFile,
									true
								);
							});
						}
					}
				]
			],
			argsResolver: [
				'$stateParams',
				async $stateParams => {
					return {
						siteName: $stateParams.site || $stateParams.siteName
					};
				}
			]
		}),
		elm({
			name: 'site.GoogleBrandPagesNew',
			moduleName: 'BrandManagement.Google.Main',
			url: '/brandmanagement/google',
			requiredPermission: 'permission/location.view',
			pageTitle: 'listings.navigation.brand_pages_google',
			subscriptions: [
				'$document',
				'pmtElmService',
				($document, pmtElmService) => [
					{
						id: 'CropImage',
						f: async args => {
							const { cropperId, fileSuffix, maxWidth, maxHeight } = args;
							// I don't know why the document is an array, but at this point I am afraid to ask
							const cropper = $document[0].getElementById(cropperId);

							if (!cropper) {
								return;
							}

							const originalCanvas = await cropper.captureImage();
							const { height, width } = originalCanvas;

							const newWidth = width > maxWidth ? maxWidth : width;
							const newHeight = height > maxHeight ? maxHeight : height;

							const scaledCanvas = $document[0].createElement('canvas');
							const scaledCtx = scaledCanvas.getContext('2d');

							scaledCanvas.width = newWidth;
							scaledCanvas.height = newHeight;

							scaledCtx.drawImage(originalCanvas, 0, 0, newWidth, newHeight);

							scaledCanvas.toBlob(blob => {
								const asFile = new File([blob], 'cropped-' + fileSuffix + '.png', {
									type: blob.type
								});
								pmtElmService.sendData(
									'BrandManagement.Google.Main',
									'onImageCaptured_Google',
									asFile,
									true
								);
							});
						}
					}
				]
			],
			argsResolver: [
				'$stateParams',
				async $stateParams => {
					return {
						siteName: $stateParams.site || $stateParams.siteName
					};
				}
			]
		}),
		{
			name: 'site.Networks.FacebookBrandPages',
			url: '/facebook/:brandPageId',
			redirectTo: 'site.FacebookBrandPagesNew',
			requiredPermission: 'permission/location.view'
		},
		{
			name: 'site.Networks.GoogleBrandPages',
			url: '/google/:accountId',
			requiredPermission: 'permission/location.view',
			redirectTo: 'site.GoogleBrandPagesNew'
		},
		elm({
			name: 'site.NetworksListView',
			moduleName: 'Directories.NetworkList.Main',
			url: '/directories',
			requiredPermission: 'permission/location.view',
			pageTitle: 'listings.navigation.directories',
			argsResolver: [
				'$stateParams',
				'auth',
				async ($stateParams, auth) => {
					const user = await auth.getUser($stateParams.site);
					return {
						siteName: $stateParams.site || $stateParams.siteName,
						bulkVerifiedEligible: user.selectedSite.bulkVerifiedEligible || false,
						appleOAuth: isAppleOAuthConnected(user)
					};
				}
			]
		}),
		elm({
			name: 'site.NetworksListDetail',
			moduleName: 'Directories.NetworkListDetail.Main',
			url: '/directories/:network',
			requiredPermission: 'permission/location.view',
			argsResolver: ['$stateParams', $stateParams => ({ network: $stateParams.network })],
			pageTitle: 'listings.navigation.directory_details'
		})
	];
};

module.exports = {
	networksStates
};
